// Add your custom JS here.
/*document.addEventListener("DOMContentLoaded", function () {
  GLightbox({
    selector: '.glightbox',
    loop: true
  });
});*/
document.addEventListener('DOMContentLoaded', function() {
    // Inizializza GLightbox per tutte le gallery
    if (typeof GLightbox !== 'undefined') {
        
        const lightbox = GLightbox({
            // MODIFICA QUI:
            // Ora accetta sia elementi con classe .glightbox 
            // SIA qualsiasi link dentro una slide del tuo carosello specifico
            selector: '.glightbox, .gallerypageSwiper .swiper-slide a', 
            
            touchNavigation: true,
            loop: true,
            autoplayVideos: true
        });
        
        // Refresh GLightbox (utile se Swiper clona le slide per il loop infinito)
        lightbox.reload();
    }
});


document.addEventListener('DOMContentLoaded', function() {
    const swipers = document.querySelectorAll('.gallerypageSwiper');
    
    swipers.forEach(function(swiperElement) {
        new Swiper(swiperElement, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: swiperElement.querySelector('.swiper-pagination'),
                clickable: true,
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
        });
    });
});

// elements
var elements_to_watch = document.querySelectorAll('.animate');
// callback 
var callback = function(items){
  items.forEach((item) => {
    if(item.isIntersecting){
      item.target.classList.add("show");
    } else{
   //   item.target.classList.remove("in-page");
    }
  });
}
// observer
var observer = new IntersectionObserver(callback, { threshold: 0.3 } );
// apply
elements_to_watch.forEach((element) => {
  observer.observe(element); 
});
/*
function updateMaskSize() {
  const vw = window.innerWidth;
  const tileW = Math.round((1440 * 1440) / vw); // ~2074px a 1000vw, ~4000px a 520vw
  document.documentElement.style.setProperty('--mask-tile-w', tileW + 'px');
}*/